var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSaveRecordMutation } from "@/store/api";
import { Input, Textarea } from "@mui/joy";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
export default function EditView() {
    var _this = this;
    var t = useTranslation([
        "Administration",
        "common",
        "include",
        "DynamicFields",
        "ACLRoles",
    ]).t;
    var navigate = useNavigate();
    var _a = useState({
        name: "",
        description: "",
    }), role = _a[0], setRole = _a[1];
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setRole(function (prevRole) {
            var _a;
            return (__assign(__assign({}, prevRole), (_a = {}, _a[name] = value, _a)));
        });
    };
    var saveRecordMutation = useSaveRecordMutation()[0];
    var saveRole = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, recordId, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, saveRecordMutation({
                            body: { module: "ACLRoles", record: role }, // Ensure record has valid data here
                        }).unwrap()];
                case 1:
                    result = _b.sent();
                    recordId = (_a = result.data) === null || _a === void 0 ? void 0 : _a.recordId;
                    if (recordId) {
                        navigate("/modules/ACLRoles/DetailView/".concat(recordId));
                    }
                    toast.success("Enregistrement terminé.");
                    navigate("/modules/ACLRoles");
                    console.log("Navigation triggered");
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error("Error saving record:", error_1);
                    toast.error("Failed to save record");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", __assign({ className: "p-3", style: { overflowY: "auto" } }, { children: _jsx("div", __assign({ className: "columns" }, { children: _jsxs("div", __assign({ className: "column" }, { children: [_jsx("h1", __assign({ className: "title is-4" }, { children: t("LBL_MANAGE_ROLES_TITLE", { ns: "Administration" }) })), _jsx("button", __assign({ className: "button primary", onClick: saveRole }, { children: t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" }) })), _jsxs("div", __assign({ className: "card" }, { children: [_jsx("header", __assign({ className: "card-header" }, { children: _jsx("p", __assign({ className: "card-header-title" }, { children: t("LBL_CREATE_ROLE", { ns: "ACLRoles" }) })) })), _jsxs("div", __assign({ className: "card-content" }, { children: [_jsxs("div", __assign({ className: "field is-horizontal" }, { children: [_jsx("div", __assign({ className: "field-label is-small" }, { children: _jsx("label", __assign({ className: "label" }, { children: t("LBL_NAME", { ns: "ACLRoles" }) })) })), _jsx("div", __assign({ className: "field-body" }, { children: _jsx("div", __assign({ className: "field is-expanded" }, { children: _jsx("div", __assign({ className: "field is-small" }, { children: _jsx("p", __assign({ className: "control" }, { children: _jsx(Input, { type: "text", name: "name", className: " w-1/3 border border-gray-300 rounded-md p-1", value: role.name, onChange: handleInputChange }) })) })) })) }))] })), _jsxs("div", __assign({ className: "field is-horizontal" }, { children: [_jsx("div", __assign({ className: "field-label is-small" }, { children: _jsx("label", __assign({ className: "label" }, { children: t("LBL_DESCRIPTION", { ns: "ACLRoles" }) })) })), _jsx("div", __assign({ className: "field-body" }, { children: _jsx("div", __assign({ className: "field is-expanded" }, { children: _jsx("div", __assign({ className: "field is-small" }, { children: _jsx("p", __assign({ className: "control" }, { children: _jsx(Textarea, { name: "description", className: " w-1/3 border border-gray-300 rounded-md p-1", value: role.description, onChange: handleInputChange, minRows: 3, maxRows: 5 }) })) })) })) }))] }))] }))] }))] })) })) })));
}
